export function isEnum(value, values) {
  return typeof value === 'string' && Object.values(values).includes(value);
}